import { render, staticRenderFns } from "./ContractChange.vue?vue&type=template&id=3527993a"
import script from "./ContractChange.vue?vue&type=script&lang=js"
export * from "./ContractChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports